/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * System log track event request.
 */
export interface SystemLogTrackEventRequest {
  message: string;
  reportingCode?: SystemLogTrackEventRequest.ReportingCodeEnum;
  accountId?: number;
}
export namespace SystemLogTrackEventRequest {
  export const ReportingCodeEnum = {
    Blocked: 'BLOCKED',
    NoAckFromLp: 'NO_ACK_FROM_LP',
    LongAckFromLp: 'LONG_ACK_FROM_LP',
    UnregisteredAckFromLp: 'UNREGISTERED_ACK_FROM_LP',
    FireblocksAlert: 'FIREBLOCKS_ALERT',
    ConfigurationAlert: 'CONFIGURATION_ALERT',
    AlgoExecutionAlert: 'ALGO_EXECUTION_ALERT',
    BBookPairStatusAlert: 'B_BOOK_PAIR_STATUS_ALERT',
    WrongExecutionWithLp: 'WRONG_EXECUTION_WITH_LP',
    WarnExecutionWithLp: 'WARN_EXECUTION_WITH_LP',
    MainBookAlert: 'MAIN_BOOK_ALERT',
    ZerohashNoFundsAlert: 'ZEROHASH_NO_FUNDS_ALERT',
    SyntheticPricingAlert: 'SYNTHETIC_PRICING_ALERT',
    BankAlert: 'BANK_ALERT',
    ComplianceAlert: 'COMPLIANCE_ALERT',
  } as const;
  export type ReportingCodeEnum = (typeof ReportingCodeEnum)[keyof typeof ReportingCodeEnum];
}
